// extracted by mini-css-extract-plugin
export default {"box":"CustomTooltip_box__cm6MQ","item":"CustomTooltip_item__roR1T","text":"CustomTooltip_text__9s2ie","name":"CustomTooltip_name__ZQsp2","square":"CustomTooltip_square__bfmDw"};